import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { AvailableCashBalance } from '../AvailableCashBalance';
import { PaidExpensesVsReceivedIncomesPieChart } from '../PaidExpensesVsReceviedIncomesPieChart';
import { ExpensesToBePaidVsIncomesToBeReceived } from '../ExpensesToBePaidVsIncomesToBeReceivedPieChart';

export function OverviewTabWeb({ period }) {
  return (
    <Grid container spacing={3}>
      <Grid size={12}>
        <AvailableCashBalance {...period} />
      </Grid>

      <Grid size={6} display="flex" justifyContent="center">
        <PaidExpensesVsReceivedIncomesPieChart {...period} />
      </Grid>

      <Grid size={6} display="flex" justifyContent="center">
        <ExpensesToBePaidVsIncomesToBeReceived {...period} />
      </Grid>
    </Grid>
  );
}

OverviewTabWeb.propTypes = {
  period: PropTypes.shape({
    selectedDate: PropTypes.object.isRequired,
    viewByYear: PropTypes.bool.isRequired,
    viewAllPeriod: PropTypes.bool.isRequired,
  }).isRequired,
};
